import React, { useState, useEffect } from "react"
import _ from "lodash"
import moment from "moment"
import { Row, Col, Form, Label, FormGroup } from "reactstrap";

import FormField from './field_v2'
import { verifyEmail } from './validations'

function CustomForm(props) {

    let { id, inputs, onChange, filesUrls, readOnly } = props
    let SUCCESS_CLASS = 'has-success', DANGER_CLASS = 'has-danger'


    // validate the input (in each change) based on its type
    const change = (event, stateName, type, required) => {

        if (readOnly) return

        let className = ""

        switch (type) {

            case "TextInput":
                if (stateName === 'email') {
                    className = !verifyEmail(event.target.value) ? DANGER_CLASS : SUCCESS_CLASS
                    break
                }
                if (stateName === 'password') {
                    className = (event.target.value.length < 8) ? DANGER_CLASS : SUCCESS_CLASS
                    break
                }

            case "NumberInput":
            case "list":
                className = required && _.isEmpty(event.target.value) ? DANGER_CLASS : SUCCESS_CLASS
                break

            case "Dropdown2":
                className = required && _.isEmpty(event) ? DANGER_CLASS : SUCCESS_CLASS
                break

            case "TextInputDueDate":
            case "":
                className = required && !moment.isMoment(event) ? DANGER_CLASS : SUCCESS_CLASS
                break

            default:
                break
        }

        let val

        if (type === "TextInputDueDate" || type === "TextInputDate") {
            
            val = moment.isMoment(event)? event : ''

        } else if (type === "Dropdown2") {

            val = event

        } else if (type === "RadioButtons" || type === "Checkboxes") {
            val = event.target.id // 

        } else {
            val = event.target.value
        }

        onChange(stateName, val, className)

    }

    let getFormFields = () => {
        let fieldsGrid = []

        _.map(inputs, (input, key) => {

            fieldsGrid.push(
                <Row key={key + input.stateName} className='py-2'>

                    {!input.label && (
                        <Col md={12}>
                            {/* <Label sm="5" className={`${input.type === "checkbox" ? "mt-3" : input.type === "image" ? "mt-4" : ""}`}> */}
                            <label sm="5" className={`mx-0 px-0`}>
                                {input.name}
                            </label>
                            <span className='text-danger px-1'>{input.required ? '*' : ''}</span>
                        </Col>
                    )}

                    <Col
                        style={{ alignSelf: 'center' }}
                    // md={input.colSize ?? 12}
                    // style={{ marginTop: input.type === "text" ? -20 : 0 }}
                    >
                        <FormGroup className={input.state}>
                            <FormField
                                input={input}
                                onChange={change}
                                isReadOnly={readOnly}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            )

        })

        return fieldsGrid

    }

    return (
        <Form id={id} >

            {getFormFields()}

            {/* list of Attachments links */}
            {filesUrls && (
                <>
                    <p>Attachments Files</p>
                    {_.map(filesUrls, (url) => (
                        <a key={url.name} href={url.url} target="_blank" className='px-2'>{url.name}</a>
                    ))}
                </>
            )}

        </Form>

    )

}

export default CustomForm
